import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { CreatePasswordComponent } from './create-password.component';

const createPassRoutes: Routes = [
  { path: '', component: CreatePasswordComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(createPassRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})

export class CreatePassRoutingModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/create-password/create-password.routing.ts